import script from "./aMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./aMenu.vue?vue&type=script&setup=true&lang=js"

import "./aMenu.vue?vue&type=style&index=0&id=032e2970&scoped=true&lang=css"
const cssModules = {}
import style1 from "./aMenu.vue?vue&type=style&index=1&id=032e2970&module=true&lang=scss"
cssModules["$style"] = style1

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-032e2970"]])

export default __exports__